import DotDotDotMenu from '~/components/DotDotDotMenu';
import { ucfirst } from '~/lib/Utils';
import { formatDate } from '~/lib/DateTime';
import { CheckIcon } from '@heroicons/react/24/outline';
import * as Toast from '~/lib/Toast';
import useBusinessPostApi from '~/lib/useBusinessPostApi';
import useDelete from '~/lib/useDelete';
import { getPaymentMethodDetails } from '~/lib/PaymentMethodHelpers';

const SavedPaymentMethodRowDetails = ({
    className,
    paymentMethod,
    isPreviouslyUsed,
    setIsDeleted,
    refetch,
}) => {
    const { save: saveMakeDefault, isSaving: isMakingDefault } =
        useBusinessPostApi(
            `/payments/saved-method/${paymentMethod.id}/default`,
        );
    const { saveDelete, isDeleting } = useDelete(
        `/payments/saved-method/${paymentMethod.id}/delete`,
    );

    function doDelete() {
        console.log('doing delete');
        saveDelete().then(() => {
            Toast.success('Successfully removed payment method');
            if (typeof setIsDeleted === 'function') setIsDeleted(true);
            refetch();
        });
    }

    function doMakeDefault() {
        saveMakeDefault().then(() => {
            Toast.success('Successfully marked as default');
            refetch();
        });
    }

    let menuOptions = [];
    if (!paymentMethod.is_default) {
        menuOptions.push({
            name: isMakingDefault ? 'Making default...' : 'Make Default',
            icon: <CheckIcon />,
            onClick: doMakeDefault,
        });
    }

    const { title, description } = getPaymentMethodDetails(paymentMethod);

    return (
        <div className={className}>
            <div className="flex items-center justify-between">
                <div className="flex items-center space-x-4">
                    <div>{title}</div>
                    {isPreviouslyUsed && !paymentMethod?.is_default && (
                        <div className="text-gray-500">(Previously used)</div>
                    )}
                    {!!paymentMethod?.is_default && (
                        <div className="text-gray-500">(Default)</div>
                    )}
                </div>
                <DotDotDotMenu
                    options={[
                        ...menuOptions,
                        {
                            name: isDeleting ? 'Deleting...' : 'Delete',
                            isDelete: true,
                            onClick: doDelete,
                        },
                    ]}
                />
            </div>
            <div className="text-sm text-gray-500">{description}</div>
        </div>
    );
};

export default SavedPaymentMethodRowDetails;
